<template>
    <div id="browse">
        <Navi currentPage="3"></Navi>
        <div class="body_container main_context">
            <div class="breadcrumb_con">
                <el-breadcrumb separator="/" class="breadcrumb">
                    <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                    <el-breadcrumb-item>Results</el-breadcrumb-item>
                    <el-breadcrumb-item>Cell types</el-breadcrumb-item>
                </el-breadcrumb>

            </div>
            <div v-if="loading" class="pcga-loading">
                <el-row
                    v-loading="true"
                    element-loading-background="rgba(255, 255, 255, 1)"
                    style="height:100%"
                ></el-row>
                <!-- <pcga-loading></pcga-loading> -->
            </div>
            <div v-if="!loading">
                <div class="results" v-if="!error_page">
                    <div class="task_results">
                        <el-collapse v-model="activeCollapse1">
                            <el-collapse-item name="1">
                                <template slot="title">
                                    <i class="header-icon el-icon-info"></i> Summary of tissues/single cell types
                                </template>
                                <el-descriptions class="margin-top" :column="3" border>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-user"></i>
                                            Cell type ID
                                        </template>
                                        {{ meta.cell_type_id }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                         <i class="el-icon-mobile-phone"></i>
                                            Cell type
                                        </template>
                                        {{ meta.cell_type }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-tickets"></i>
                                            Data type
                                        </template>
                                        <el-tag size="middle" type="success">{{ meta.type_label }}</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-location-outline"></i>
                                            Source organ
                                        </template>
                                        {{meta.source }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            Category
                                        </template>
                                        <el-tag size="middle">{{ meta.category_source }}</el-tag>
                                    </el-descriptions-item>


                                </el-descriptions>
                            </el-collapse-item>
                        
                                        <el-collapse-item name="2">
                                            <template slot="title">
                                                <i class="header-icon el-icon-info"></i> Seletive expression
                                            </template>
                                            <div
                                                class="pcga-result-des"
                                            >Here are seletively expressed genes (P &lt; 0.05). The selective expression is measured by REZ (robust Z-score), which is a part of DESE and PCGA 
                                                (see details in Help section). In short, the larger the Z-score, the more selectively the gene is expressed in the tissues/cell types.</div>
                                            <div class="pcga-result-table-box pcga-result-box">
                                                <div>
                                                    <Tab
                                                        :table_data="gene_table_data"
                                                        :loading="gene_table_data.loading"
                                                        :loadData="loadGeneData"
                                                    ></Tab>
                                                </div>
                                            </div>
                                        </el-collapse-item>
                                        <el-collapse-item  name="3">
                                            <template slot="title">
                                                <i class="header-icon el-icon-info"></i> Associated phenotypes
                                            </template>
                                            <div
                                                class="pcga-result-des"
                                            >Here are associated phenotypes with P &lt; 0.05. The significance in pie plot is Bonferroni family-wise error rate (FWER) &lt; 0.05.</div>
                                            <div class="pcga-result-table-box pcga-result-box">
                                                <div>
                                                    <CellTab
                                                        :table_data="phenotype_table_data"
                                                        :loading="phenotype_table_data.loading"
                                                        :loadData="loadPhenotypeData"
                                                    ></CellTab>
                                                </div>
                                            </div>
                                            <div class="pcga-result-fig-box pcga-result-box" v-if="!phenotype_box_data.empty">
                                                <div class="pcga-result-fig1-box">
                                                    <Box
                                                        :fig_data="phenotype_box_data"
                                                        :loading="phenotype_box_data.loading"
                                                        :empty="phenotype_box_data.empty"
                                                    ></Box>
                                                    <Pie
                                                        :fig_data="phenotype_pie_data"
                                                        :loading="phenotype_pie_data.loading"
                                                        :empty="phenotype_pie_data.empty"
                                                    ></Pie>
                                                </div>
                                            </div>
                                        </el-collapse-item>
                        </el-collapse>
                    </div>
                </div>
                <div class="results" v-else>
                    <el-result icon="error" title="Invalid link" :subTitle="error_msg"></el-result>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Navi from "@/components/navigate.vue";
import Footer from "@/components/footer.vue";
import Tab from "@/components/plot/common_table.vue";
import CellTab from "@/components/plot/cell_table.vue";
import Box from "@/components/plot/box.vue";
import Pie from "@/components/plot/pie.vue";
import axios from "axios/dist/axios.min";
import { api_dir,echartTable2vxeTable } from "@/bus.js";

export default {
    name: "browse",
    components: { Navi, Footer, Tab, Box, Pie, CellTab},
    data: function () {
        return {
            activeCollapse1:['1','2','3'],
            activeCollapse2:[],
            error_page: false,
            loading: true,
            id: '',
            error_msg: "The url doesn't contain cell type ID!",
            rna_db: [
                { 'id': 'gtex', 'label': 'Human tissues' },
                { 'id': 'sc_hs', 'label': 'Human single cell types' },
                { 'id': 'sc_mm', 'label': 'Mouse single cell types' }
            ],
            tabelData: [],
            loading1: false,
            cols: [],

            meta:{},
            gene_table_data: {
                loading: false,
                sortConfig: { remote: true, defaultSort: { field: "z", order: "desc" } },
                tableColumn: [
                    { field: 'gene', title: 'Gene symbol', width: '30%', msg: { message: 'Gene symbol in HGNC' },sort:true },
                    { field: 'mean', title: 'Mean (CPM)', width: '20%', msg: { message: 'Mean of expression value (CPM, count per million)' },sort:true },
                    { field: 'z', title: 'Z-score (REZ)', width: '25%', msg: { message: 'Z-score of REZ (for measuring the selective expression)' },sort:true },
                    { field: 'p', title: 'P-value (REZ)', width: '25%', msg: { message: 'P-value of REZ (for measuring the selective expression)' },sort:true },
                ],
                tableData: [],
            },
            phenotype_table_data: {
                loading: false,
                sortConfig: { remote: true, defaultSort: { field: "p", order: "asc" } },
                tableColumn: [
                    { field: 'id', title: 'GWAS ID', width: '20%', msg: { message: 'GWAS ID' },sort:true },
                    { field: 'trait', title: 'Phenotype name', width: '35%', msg: { message: 'Phenotype description of GWAS' },sort:true },
                    { field: 'mesh_term', title: 'MeSH term', width: '20%', msg: { message: 'MeSH term of phenotype' },sort:true },
                    { field: 'category', title: 'Category', width: '15%', msg: { message: 'Category of phenotype' },sort:true },
                    { field: 'p', title: 'P-value', width: '10%', msg: { message: 'P-value of association between phenotype and tissue/single cell type' },sort:true },
                ],
                tableData: [],
            },

            phenotype_box_data: {
                loading: true,
                width: "550px",
                height: "400px",
                plot_data: {
                    data: [],
                    val_col: '',
                    cate_col: '',
                    detail_cols: [],
                    title: '-log10(P) of associated phenotypes',
                },
                empty:false
            },
            phenotype_pie_data: {
                loading: true,
                width: "600px",
                height: "400px",
                plot_data: {
                    data: [],
                    title: 'Categories of significant phenotypes',
                },
                empty:false
            },
        };
    },
    created: function(){
        this.getTaskID();
    },
    mounted: function () {
        this.loadMetaData();
        this.loadGeneData();
        this.loadPhenotypeData();
    },

    methods: {
        getTaskID() {
            if ('id' in this.$route.query) {
                this.id = this.$route.query.id;
            } else {
                _this.error_page = true;
            }
        },
        loadMetaData() {
            var _this = this
            var para = { 'action': 'search_cell', 'id': this.id }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    _this.meta = res[0];
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },

        loadGeneData() {
            var _this = this
            _this.gene_table_data.loading = true;
            var para = {
                'action': 'cell_assoc_gene_full',
                'cell_id': this.id,
            }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    //do table
                    var res = JSON.parse(JSON.stringify(response.data));
                    let table_data = echartTable2vxeTable(res);
                    for(var s of table_data){
                        s['gene']='<a target="_blank" class="table_a" href="#/results/gene?id='+s['gene']+'">'+s['gene']+'</a>'
                    }
                    _this.gene_table_data.tableData=table_data;
                    _this.gene_table_data.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },

        loadPhenotypeData() {
            var _this = this
            _this.phenotype_box_data.loading = true;
            _this.phenotype_pie_data.loading = true;
            _this.phenotype_table_data.loading = true;
            _this.phenotype_box_data.empty = false;
            _this.phenotype_pie_data.empty = false;
            var para = {
                'action': 'cell_assoc_phenotype_full',
                'cell_id': this.id,
            }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    //do table
                    let table_data = echartTable2vxeTable(res);
                    for(var s of table_data){
                        s['id']='<a target="_blank" class="table_a" href="#/results/phenotype?id='+s['id']+'">'+s['id']+'</a>'
                        if(s['p']<0.01/s['count']){
                            s['rate']=3
                        }else if(s['p']<0.05/s['count']){
                            s['rate']=2
                        }else if(s['p']<0.05){
                            s['rate']=1
                        }
                    }
                    _this.phenotype_table_data.tableData=table_data;
                    _this.phenotype_table_data.loading = false;
                    if(res.length==0){
                        _this.phenotype_box_data.empty = true;
                        _this.phenotype_pie_data.empty = true;
                        _this.phenotype_box_data.loading = false;
                        _this.phenotype_pie_data.loading = false;
                    }else{
                        // console.log(_this.phenotype_pie_data.loading)
                    //do fig
                    for (var i = 1; i < res.length; i++) {
                        if(res[i][0]==0){
                            res[i][0]=160
                        }else{
                            res[i][0] = -Math.log10(res[i][0]);
                        }
                    }
                    var switch_name = {
                        'p': '-log10(P)',
                        'id': 'GWAS ID',
                        "trait": "Phenotype name",
                        "mesh_term": "MeSH term",
                        "category": "Category",
                        'count':'count'
                    }
                    for (var i = 0; i < res[0].length; i++) {
                        res[0][i] = switch_name[res[0][i]];
                    }
                    // console.log(res)
                    _this.phenotype_box_data.plot_data.data = res;
                    _this.phenotype_box_data.plot_data.val_col = '-log10(P)';
                    _this.phenotype_box_data.plot_data.cate_col = 'Category';
                    _this.phenotype_box_data.plot_data.detail_cols = ['GWAS ID', 'Phenotype name', 'Category', '-log10(P)', 'MeSH term'];
                    _this.phenotype_box_data.loading = false;
                    var category_idx = res[0].indexOf('Category');
                    var p_idx = res[0].indexOf('-log10(P)');
                    var count_idx=res[0].indexOf('count');
                    var k = 0;
                    var map_val = {};
                    for (var i = 1; i < res.length; i++) {
                        var pcut= -Math.log10(0.05 / (res[i][count_idx]));
                        if (res[i][p_idx] >= pcut) {
                            if (!(res[i][category_idx] in map_val)) {
                                map_val[res[i][category_idx]] = 0;
                            }
                            map_val[res[i][category_idx]] += 1;
                        }
                    }
                    var pdata = []
                    for (var x in map_val) {
                        pdata.push({ name: x, value: map_val[x] });
                    }
                    // console.log(pdata)
                    _this.phenotype_pie_data.plot_data.data = pdata;
                    _this.phenotype_pie_data.loading = false;   
                    }                 

                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },

        switchRNAdb(tab) {
            this.active_RNAdb = tab.name;
            this.loadGeneData();
            this.loadPhenotypeData();
        }

    },
};
</script>



<style>
.tip_box {
    padding: 20px 20px;
    background-color: #fdf6ec;
}
.el-collapse-item__header {
    font-size: 16px;
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/views/results/cell.vue